// Exercices Salaires interactifs — calculs + QCM + écritures
// Taux 2024 · Plan comptable PME suisse

export const salairesCalcExercises = [
  {
    id: 'sal-q-01', group: 'salaires-calcul', type: 'qcm', tag: 'salaires', difficulty: 1,
    title: 'Qui supporte les charges patronales ?',
    description: 'Les charges sociales patronales (AVS, AC, LPP — part employeur) sont :',
    options: [
      { id: 'a', text: 'Déduites du salaire brut de l\'employé', correct: false },
      { id: 'b', text: 'Un coût supplémentaire pour l\'entreprise, s\'ajoutant au salaire brut', correct: true },
      { id: 'c', text: 'Optionnelles selon le contrat de travail', correct: false },
      { id: 'd', text: 'Identiques aux déductions employé', correct: false },
    ],
    explanation: 'Les charges patronales s\'ajoutent au salaire brut — elles ne sont pas déduites du salaire de l\'employé. Coût total = Salaire brut + Charges patronales.',
  },
  {
    id: 'sal-q-02', group: 'salaires-calcul', type: 'qcm', tag: 'salaires', difficulty: 1,
    title: 'Taux AVS/AI/APG 2024',
    description: 'Quel est le taux AVS/AI/APG 2024, pour l\'employé ET l\'employeur ?',
    options: [
      { id: 'a', text: '5.3% chacun (10.6% au total)', correct: true },
      { id: 'b', text: '5.5% chacun (11% au total)', correct: false },
      { id: 'c', text: '4.35% employé / 6.25% employeur', correct: false },
      { id: 'd', text: '5.3% uniquement pour l\'employeur', correct: false },
    ],
    explanation: 'Taux 2024 : AVS/AI/APG 5.3% employé + 5.3% employeur = 10.6% au total sur le salaire brut. Taux paritaire.',
  },
  {
    id: 'sal-q-03', group: 'salaires-calcul', type: 'qcm', tag: 'salaires', difficulty: 2,
    title: 'Plafond AC',
    description: 'M. Gros gagne CHF 15\'000 brut/mois. Sur quelle base calcule-t-on l\'assurance-chômage (AC) ?',
    options: [
      { id: 'a', text: 'CHF 15\'000 (salaire entier)', correct: false },
      { id: 'b', text: 'CHF 12\'350 (plafond mensuel)', correct: true },
      { id: 'c', text: 'CHF 10\'000', correct: false },
      { id: 'd', text: 'CHF 13\'500', correct: false },
    ],
    explanation: 'L\'AC est plafonnée à CHF 148\'200/an soit CHF 12\'350/mois. Pour M. Gros : AC = 12\'350 × 1.1% = CHF 135.85. La tranche de CHF 2\'650 est exemptée d\'AC.',
  },
  {
    id: 'sal-q-04', group: 'salaires-calcul', type: 'qcm', tag: 'salaires', difficulty: 2,
    title: 'Compte impôt à la source',
    description: 'L\'impôt à la source (IS) retenu sur le salaire d\'un employé permis B est comptabilisé dans :',
    options: [
      { id: 'a', text: '2270 Charges sociales à payer', correct: false },
      { id: 'b', text: '2271 Impôt à la source à payer', correct: true },
      { id: 'c', text: '8500 Impôts directs', correct: false },
      { id: 'd', text: '5000 Salaires', correct: false },
    ],
    explanation: 'L\'IS est versé à l\'administration fiscale cantonale — pas aux caisses sociales. Il va au compte 2271, séparé de 2270.',
  },
  {
    id: 'sal-q-05', group: 'salaires-calcul', type: 'qcm', tag: 'salaires', difficulty: 3,
    title: 'Coût employeur total',
    description: 'Théo Keller : brut CHF 6\'000 — déductions employé CHF 744 — charges patronales CHF 1\'014. Le coût mensuel est :',
    options: [
      { id: 'a', text: 'CHF 5\'256 (salaire net versé)', correct: false },
      { id: 'b', text: 'CHF 6\'000 (salaire brut)', correct: false },
      { id: 'c', text: 'CHF 7\'014 (brut + charges patronales)', correct: true },
      { id: 'd', text: 'CHF 6\'744 (brut + déductions employé)', correct: false },
    ],
    explanation: 'Coût employeur = Brut + Charges patronales = 6\'000 + 1\'014 = CHF 7\'014. Les déductions (CHF 744) sont dans le brut — elles réduisent ce que Keller reçoit (net = CHF 5\'256).',
  },
  {
    id: 'sal-calc-01', group: 'salaires-calcul', type: 'calcul', tag: 'salaires', difficulty: 2,
    title: 'Calculer le salaire net — Théo Keller',
    description: 'Calculez les déductions employé et le salaire net de Théo Keller.',
    note: 'Taux 2024 : AVS/AI/APG 5.3% — AC 1.1% — LAANP 1.0% — LPP forfait.',
    data: [
      { label: 'Salaire brut mensuel', value: 'CHF 7\'200.00' },
      { label: 'LPP employé (forfait)', value: 'CHF 360.00' },
    ],
    champs: [
      { id: 'avs', label: 'AVS/AI/APG (5.3%)', placeholder: '381.60', correct: 381.60, tol: 0.10, hint: '7\'200 × 5.3%' },
      { id: 'ac', label: 'AC (1.1%)', placeholder: '79.20', correct: 79.20, tol: 0.10, hint: '7\'200 × 1.1%' },
      { id: 'lpp', label: 'LPP employé', placeholder: '360.00', correct: 360.00, tol: 0.01, hint: 'Forfait donné' },
      { id: 'laanp', label: 'LAANP (1.0%)', placeholder: '72.00', correct: 72.00, tol: 0.10, hint: '7\'200 × 1.0%' },
      { id: 'total_ded', label: 'Total déductions', placeholder: '892.80', correct: 892.80, tol: 0.10, hint: 'Somme des 4 déductions' },
      { id: 'net', label: 'Salaire net', placeholder: '6\'307.20', correct: 6307.20, tol: 0.10, hint: '7\'200 − total déductions' },
    ],
    correction: 'AVS : 7\'200 × 5.3% = 381.60 — AC : 79.20 — LPP : 360.00 — LAANP : 72.00\nTotal déductions : 892.80 — Net : 7\'200 − 892.80 = CHF 6\'307.20',
  },
  {
    id: 'sal-calc-02', group: 'salaires-calcul', type: 'calcul', tag: 'salaires', difficulty: 2,
    title: 'Charges patronales et coût total — Théo Keller',
    description: 'Calculez les charges patronales et le coût total employeur pour Théo Keller.',
    note: 'Les charges patronales s\'ajoutent au brut — elles ne sont pas déduites du salaire.',
    data: [
      { label: 'Salaire brut', value: 'CHF 7\'200.00' },
      { label: 'LPP patronal (forfait)', value: 'CHF 432.00' },
    ],
    champs: [
      { id: 'avs_p', label: 'AVS/AI/APG patronal (5.3%)', placeholder: '381.60', correct: 381.60, tol: 0.10, hint: '7\'200 × 5.3%' },
      { id: 'ac_p', label: 'AC patronal (1.1%)', placeholder: '79.20', correct: 79.20, tol: 0.10, hint: '7\'200 × 1.1%' },
      { id: 'lpp_p', label: 'LPP patronal', placeholder: '432.00', correct: 432.00, tol: 0.01, hint: 'Forfait donné' },
      { id: 'laa_p', label: 'LAA prof. (0.5%)', placeholder: '36.00', correct: 36.00, tol: 0.10, hint: '7\'200 × 0.5%' },
      { id: 'total_pat', label: 'Total charges patronales', placeholder: '928.80', correct: 928.80, tol: 0.10, hint: 'Somme des 4' },
      { id: 'cout_total', label: 'Coût total employeur', placeholder: '8\'128.80', correct: 8128.80, tol: 0.10, hint: 'Brut + charges patronales' },
    ],
    correction: 'AVS pat. : 381.60 — AC pat. : 79.20 — LPP pat. : 432.00 — LAA : 36.00\nTotal charges pat. : 928.80 — Coût total : 7\'200 + 928.80 = CHF 8\'128.80',
  },
  {
    id: 'sal-calc-03', group: 'salaires-calcul', type: 'calcul', tag: 'salaires', difficulty: 2,
    title: 'Temps partiel 60% — Léa Meyer',
    description: 'Calculez le brut proratisé et le salaire net de Léa Meyer à 60%.',
    note: 'Toutes les cotisations sont calculées sur le brut effectif (60%), pas sur le 100%.',
    data: [
      { label: 'Salaire brut à 100%', value: 'CHF 6\'500.00' },
      { label: 'Taux d\'activité', value: '60%' },
      { label: 'LPP employé (forfait)', value: 'CHF 156.00' },
    ],
    champs: [
      { id: 'brut60', label: 'Salaire brut 60%', placeholder: '3\'900.00', correct: 3900, tol: 0.10, hint: '6\'500 × 60%' },
      { id: 'avs', label: 'AVS/AI/APG (5.3%)', placeholder: '206.70', correct: 206.70, tol: 0.10, hint: 'Brut 60% × 5.3%' },
      { id: 'ac', label: 'AC (1.1%)', placeholder: '42.90', correct: 42.90, tol: 0.10, hint: 'Brut 60% × 1.1%' },
      { id: 'lpp', label: 'LPP employé', placeholder: '156.00', correct: 156, tol: 0.01, hint: 'Forfait donné' },
      { id: 'laanp', label: 'LAANP (1.0%)', placeholder: '39.00', correct: 39, tol: 0.10, hint: 'Brut 60% × 1.0%' },
      { id: 'net', label: 'Salaire net', placeholder: '3\'455.40', correct: 3455.40, tol: 0.10, hint: 'Brut 60% − total déductions' },
    ],
    correction: 'Brut 60% : 6\'500 × 60% = 3\'900 — AVS : 206.70 — AC : 42.90 — LPP : 156.00 — LAANP : 39.00\nDéductions : 444.60 — Net : 3\'900 − 444.60 = CHF 3\'455.40',
  },
  {
    id: 'sal-calc-04', group: 'salaires-calcul', type: 'calcul', tag: 'salaires', difficulty: 3,
    title: 'Impôt à la source — Lucas Morel',
    description: 'Calculez les déductions et le net de Lucas Morel avec impôt à la source.',
    note: 'L\'IS est calculé sur le brut. Il va au compte 2271, séparé des cotisations sociales (2270).',
    data: [
      { label: 'Salaire brut', value: 'CHF 5\'800.00' },
      { label: 'LPP employé (forfait)', value: 'CHF 290.00' },
      { label: 'Taux IS (barème A, GE)', value: '12.5%' },
    ],
    champs: [
      { id: 'avs', label: 'AVS/AI/APG (5.3%)', placeholder: '307.40', correct: 307.40, tol: 0.10, hint: '5\'800 × 5.3%' },
      { id: 'ac', label: 'AC (1.1%)', placeholder: '63.80', correct: 63.80, tol: 0.10, hint: '5\'800 × 1.1%' },
      { id: 'lpp', label: 'LPP employé', placeholder: '290.00', correct: 290, tol: 0.01, hint: 'Forfait donné' },
      { id: 'laanp', label: 'LAANP (1.0%)', placeholder: '58.00', correct: 58, tol: 0.10, hint: '5\'800 × 1.0%' },
      { id: 'is', label: 'Impôt à la source (12.5%)', placeholder: '725.00', correct: 725, tol: 0.10, hint: '5\'800 × 12.5%' },
      { id: 'net', label: 'Salaire net versé', placeholder: '4\'355.80', correct: 4355.80, tol: 0.10, hint: 'Brut − toutes déductions' },
    ],
    correction: 'AVS : 307.40 — AC : 63.80 — LPP : 290.00 — LAANP : 58.00 — IS : 5\'800 × 12.5% = 725.00\nTotal déductions : 1\'444.20 — Net : 5\'800 − 1\'444.20 = CHF 4\'355.80',
  },
  {
    id: 'sal-calc-05', group: 'salaires-calcul', type: 'calcul', tag: 'salaires', difficulty: 3,
    title: 'Prorata de départ — Lucas Morel',
    description: 'Lucas Morel part le 20 mars. Calculez son brut proratisé et son net.',
    note: 'Prorata = brut mensuel × jours travaillés / jours ouvrables du mois.',
    data: [
      { label: 'Salaire brut mensuel', value: 'CHF 8\'400.00' },
      { label: 'Jours ouvrables mars', value: '21 jours' },
      { label: 'Jours travaillés', value: '14 jours' },
      { label: 'LPP employé (proratisé)', value: 'CHF 280.00' },
    ],
    champs: [
      { id: 'brut_pro', label: 'Salaire brut proratisé', placeholder: '5\'600.00', correct: 5600, tol: 0.10, hint: '8\'400 × 14/21' },
      { id: 'avs', label: 'AVS/AI/APG (5.3%)', placeholder: '296.80', correct: 296.80, tol: 0.10, hint: 'Brut proratisé × 5.3%' },
      { id: 'ac', label: 'AC (1.1%)', placeholder: '61.60', correct: 61.60, tol: 0.10, hint: 'Brut proratisé × 1.1%' },
      { id: 'lpp', label: 'LPP employé', placeholder: '280.00', correct: 280, tol: 0.01, hint: 'Forfait proratisé donné' },
      { id: 'laanp', label: 'LAANP (1.0%)', placeholder: '56.00', correct: 56, tol: 0.10, hint: 'Brut proratisé × 1.0%' },
      { id: 'net', label: 'Salaire net proratisé', placeholder: '4\'905.60', correct: 4905.60, tol: 0.10, hint: 'Brut proratisé − total déductions' },
    ],
    correction: 'Brut proratisé : 8\'400 × 14/21 = 5\'600 — AVS : 296.80 — AC : 61.60 — LPP : 280.00 — LAANP : 56.00\nDéductions : 694.40 — Net : 5\'600 − 694.40 = CHF 4\'905.60',
  },
  {
    id: 'sal-payslip-01', group: 'salaires-calcul', type: 'payslip-interactive', tag: 'salaires', difficulty: 2,
    title: 'Fiche de salaire — Employé standard 100%',
    description: 'Complétez la fiche de salaire de Jules Weber, employé à 100% chez SwiSSwatch SA.',
    salaire: { brut: 6500, tauxActivite: 100, mois: 'Mars 2024' },
    references: [
      { label: 'AVS/AI/APG employé', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC employé', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAANP', taux: '1.0%', base: 'Salaire brut' },
      { label: 'LPP employé', taux: 'Forfait', base: 'CHF 280.00/mois' },
      { label: 'AVS/AI/APG patronal', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC patronal', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAA prof. patronal', taux: '0.5%', base: 'Salaire brut' },
      { label: 'LPP patronal', taux: 'Forfait', base: 'CHF 336.00/mois' },
    ],
    reponses: {
      deductions: [
        { label: 'AVS/AI/APG', montant: 344.50 },
        { label: 'AC', montant: 71.50 },
        { label: 'LAANP', montant: 65.00 },
        { label: 'LPP', montant: 280.00 },
      ],
      net: 5739.00,
      chargesPatronales: [
        { label: 'AVS/AI/APG patronal', montant: 344.50 },
        { label: 'AC patronal', montant: 71.50 },
        { label: 'LAA prof.', montant: 32.50 },
        { label: 'LPP patronal', montant: 336.00 },
      ],
      totalChargesPatronales: 784.50,
      coutTotal: 7284.50,
    },
  },
  {
    id: 'sal-payslip-02', group: 'salaires-calcul', type: 'payslip-interactive', tag: 'salaires', difficulty: 2,
    title: 'Fiche de salaire — Temps partiel 60%',
    description: 'Complétez la fiche de salaire de Léa Meyer, employée à 60%.',
    salaire: { brut: 3900, tauxActivite: 60, mois: 'Avril 2024' },
    references: [
      { label: 'AVS/AI/APG employé', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC employé', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAANP', taux: '1.0%', base: 'Salaire brut' },
      { label: 'LPP employé', taux: 'Forfait', base: 'CHF 168.00/mois' },
      { label: 'AVS/AI/APG patronal', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC patronal', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAA prof. patronal', taux: '0.5%', base: 'Salaire brut' },
      { label: 'LPP patronal', taux: 'Forfait', base: 'CHF 201.60/mois' },
    ],
    reponses: {
      deductions: [
        { label: 'AVS/AI/APG', montant: 206.70 },
        { label: 'AC', montant: 42.90 },
        { label: 'LAANP', montant: 39.00 },
        { label: 'LPP', montant: 168.00 },
      ],
      net: 3443.40,
      chargesPatronales: [
        { label: 'AVS/AI/APG patronal', montant: 206.70 },
        { label: 'AC patronal', montant: 42.90 },
        { label: 'LAA prof.', montant: 19.50 },
        { label: 'LPP patronal', montant: 201.60 },
      ],
      totalChargesPatronales: 470.70,
      coutTotal: 4370.70,
    },
  },
  {
    id: 'sal-payslip-03', group: 'salaires-calcul', type: 'payslip-interactive', tag: 'salaires', difficulty: 3,
    title: 'Fiche de salaire — Permis B avec impôt à la source',
    description: 'Complétez la fiche de Lucas Morel (permis B, célibataire, barème A0).',
    salaire: { brut: 5800, tauxActivite: 100, mois: 'Mai 2024' },
    references: [
      { label: 'AVS/AI/APG employé', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC employé', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAANP', taux: '1.0%', base: 'Salaire brut' },
      { label: 'LPP employé', taux: 'Forfait', base: 'CHF 250.00/mois' },
      { label: 'AVS/AI/APG patronal', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC patronal', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAA prof. patronal', taux: '0.5%', base: 'Salaire brut' },
      { label: 'LPP patronal', taux: 'Forfait', base: 'CHF 300.00/mois' },
      { label: 'Impôt à la source (IS)', taux: '8.4%', base: 'Salaire brut (barème A0 VD)' },
    ],
    reponses: {
      deductions: [
        { label: 'AVS/AI/APG', montant: 307.40 },
        { label: 'AC', montant: 63.80 },
        { label: 'LAANP', montant: 58.00 },
        { label: 'LPP', montant: 250.00 },
        { label: 'Impôt à la source', montant: 487.20 },
      ],
      net: 4633.60,
      chargesPatronales: [
        { label: 'AVS/AI/APG patronal', montant: 307.40 },
        { label: 'AC patronal', montant: 63.80 },
        { label: 'LAA prof.', montant: 29.00 },
        { label: 'LPP patronal', montant: 300.00 },
      ],
      totalChargesPatronales: 700.20,
      coutTotal: 6500.20,
    },
  },
  {
    id: 'sal-payslip-04', group: 'salaires-calcul', type: 'payslip-interactive', tag: 'salaires', difficulty: 3,
    title: 'Fiche de salaire — Départ le 15 du mois (prorata)',
    description: 'Théo Keller quitte l\'entreprise le 15 juin. Calculez son dernier salaire (15 jours sur 30).',
    salaire: { brut: 3400, tauxActivite: 100, mois: 'Juin 2024 (prorata 15/30)' },
    note: 'Le brut est déjà proratisé : 6\'800 × 15/30 = 3\'400',
    references: [
      { label: 'AVS/AI/APG employé', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC employé', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAANP', taux: '1.0%', base: 'Salaire brut' },
      { label: 'LPP employé', taux: 'Forfait', base: 'CHF 175.00/mois' },
      { label: 'AVS/AI/APG patronal', taux: '5.3%', base: 'Salaire brut' },
      { label: 'AC patronal', taux: '1.1%', base: 'Salaire brut' },
      { label: 'LAA prof. patronal', taux: '0.5%', base: 'Salaire brut' },
      { label: 'LPP patronal', taux: 'Forfait', base: 'CHF 210.00/mois' },
    ],
    reponses: {
      deductions: [
        { label: 'AVS/AI/APG', montant: 180.20 },
        { label: 'AC', montant: 37.40 },
        { label: 'LAANP', montant: 34.00 },
        { label: 'LPP', montant: 175.00 },
      ],
      net: 2973.40,
      chargesPatronales: [
        { label: 'AVS/AI/APG patronal', montant: 180.20 },
        { label: 'AC patronal', montant: 37.40 },
        { label: 'LAA prof.', montant: 17.00 },
        { label: 'LPP patronal', montant: 210.00 },
      ],
      totalChargesPatronales: 444.60,
      coutTotal: 3844.60,
    },
  },
  {
    id: 'sal-calc-06', group: 'salaires-calcul', type: 'calcul', tag: 'salaires', difficulty: 3,
    title: 'Coût total d\'une équipe de 3 personnes',
    description: 'Calculez le coût employeur mensuel total pour 3 collaborateurs.',
    data: [
      { label: 'Employé A (100%)', value: 'Brut CHF 6\'000' },
      { label: 'Employé B (80%)', value: 'Brut CHF 4\'800' },
      { label: 'Employé C (50%)', value: 'Brut CHF 3\'000' },
      { label: 'Taux charges patronales moyen', value: '13.9% du brut' },
    ],
    champs: [
      { id: 'total_brut', label: 'Total masse salariale brute', placeholder: '13800', correct: 13800, tol: 1, hint: '6000+4800+3000' },
      { id: 'charges_pat', label: 'Charges patronales totales (13.9%)', placeholder: '1918.20', correct: 1918.20, tol: 1, hint: '13800 × 13.9%' },
      { id: 'cout_total', label: 'Coût employeur total', placeholder: '15718.20', correct: 15718.20, tol: 1, hint: '13800 + 1918.20' },
      { id: 'cout_annuel', label: 'Coût annuel (× 13 mois)', placeholder: '204336.60', correct: 204336.60, tol: 10, hint: '15718.20 × 13 (13e salaire inclus)' },
    ],
    correction: 'Masse brute : 6000+4800+3000 = 13800\nCharges patronales : 13800 × 13.9% = 1918.20\nCoût mensuel : 15718.20\nCoût annuel (13 mois) : 204336.60',
  },
  {
    id: 'sal-calc-07', group: 'salaires-calcul', type: 'calcul', tag: 'salaires', difficulty: 2,
    title: 'Calcul du 13e salaire au prorata',
    description: 'Un employé engagé le 1er avril avec un salaire brut de CHF 5\'500/mois. Calculez son 13e salaire au 31 décembre.',
    data: [
      { label: 'Date d\'entrée', value: '1er avril' },
      { label: 'Salaire brut mensuel', value: 'CHF 5\'500' },
      { label: 'Mois travaillés', value: 'Avril à décembre = 9 mois' },
    ],
    champs: [
      { id: 'mois', label: 'Nombre de mois travaillés', placeholder: '9', correct: 9, tol: 0, hint: 'Avril à décembre' },
      { id: 'treizieme', label: '13e salaire au prorata', placeholder: '4125', correct: 4125, tol: 1, hint: '5500 × 9/12' },
    ],
    correction: 'Mois travaillés : avril à décembre = 9 mois\n13e salaire = 5500 × 9/12 = CHF 4125.00',
  },
];

export const salairesEcrituresExercises = [
  {
    id: 'sal-e-01', group: 'salaires-ecritures', type: 'journal', tag: 'salaires', difficulty: 3,
    title: 'Comptabilisation salaire — étapes 1 et 2',
    description: 'Comptabilisez les étapes 1 (brut + déductions) et 2 (charges patronales) pour Théo Keller en mars.',
    note: 'Débit 5000 pour le brut. Déductions employé → 2270. Net à verser → 2160. Charges patronales → débit 5700 / crédit 2270.',
    data: [
      { label: 'Salaire brut', value: 'CHF 6\'000.00' },
      { label: 'Déductions employé', value: 'CHF 744.00' },
      { label: 'Salaire net', value: 'CHF 5\'256.00' },
      { label: 'Charges patronales', value: 'CHF 1\'014.00' },
    ],
    ecritures: [
      { id: 'e1', libelle: 'Salaire brut Keller — déductions → 2270', debit: { num: '5000', label: 'Salaires' }, credit: { num: '2270', label: 'Charges sociales à payer' }, amount: 6000, amountCredit: 744, multiLine: true },
      { id: 'e1b', libelle: 'Net à payer Keller → 2160', debit: null, credit: { num: '2160', label: 'Salaires à payer' }, amount: null, amountCredit: 5256, isSubLine: true },
      { id: 'e2', libelle: 'Charges sociales patronales mars', debit: { num: '5700', label: 'Charges sociales patronales' }, credit: { num: '2270', label: 'Charges sociales à payer' }, amount: 1014 },
    ],
  },
  {
    id: 'sal-e-02', group: 'salaires-ecritures', type: 'journal', tag: 'salaires', difficulty: 3,
    title: 'Versements — salaire net et caisses sociales',
    description: 'Passez les étapes 3 (virement salaire net) et 4 (versement caisses) pour Théo Keller.',
    data: [
      { label: 'Salaire net à verser', value: 'CHF 5\'256.00' },
      { label: 'Total à verser aux caisses', value: 'CHF 1\'758.00' },
    ],
    ecritures: [
      { id: 'e3', libelle: 'Virement salaire net Théo Keller — 05.04', debit: { num: '2160', label: 'Salaires à payer' }, credit: { num: '1020', label: 'Banque' }, amount: 5256 },
      { id: 'e4', libelle: 'Versement caisses sociales (AVS+AC+LPP+LAA)', debit: { num: '2270', label: 'Charges sociales à payer' }, credit: { num: '1020', label: 'Banque' }, amount: 1758 },
    ],
  },
  {
    id: 'sal-e-03', group: 'salaires-ecritures', type: 'journal', tag: 'salaires', difficulty: 3,
    title: 'Salaire avec impôt à la source — Lucas Morel',
    description: 'Comptabilisez le salaire de Lucas Morel avec IS : brut + déductions + IS + charges patronales.',
    note: 'L\'IS (CHF 725) va au compte 2271, séparé de 2270. Les cotisations sociales = CHF 719.20.',
    data: [
      { label: 'Salaire brut', value: 'CHF 5\'800.00' },
      { label: 'Cotisations sociales employé', value: 'CHF 719.20' },
      { label: 'Impôt à la source (12.5%)', value: 'CHF 725.00' },
      { label: 'Salaire net', value: 'CHF 4\'355.80' },
      { label: 'Charges patronales', value: 'CHF 748.20' },
    ],
    ecritures: [
      { id: 'e1', libelle: 'Salaire brut Morel — cotisations → 2270', debit: { num: '5000', label: 'Salaires' }, credit: { num: '2270', label: 'Charges sociales à payer' }, amount: 5800, amountCredit: 719.20, multiLine: true },
      { id: 'e1b', libelle: 'IS retenu → 2271', debit: null, credit: { num: '2271', label: 'IS à payer' }, amount: null, amountCredit: 725, isSubLine: true },
      { id: 'e1c', libelle: 'Net à payer Morel → 2160', debit: null, credit: { num: '2160', label: 'Salaires à payer' }, amount: null, amountCredit: 4355.80, isSubLine: true },
      { id: 'e2', libelle: 'Charges patronales Lucas Morel', debit: { num: '5700', label: 'Charges sociales patronales' }, credit: { num: '2270', label: 'Charges sociales à payer' }, amount: 748.20 },
    ],
  },
  {
    id: 'sal-e-04', group: 'salaires-ecritures', type: 'journal', tag: 'salaires', difficulty: 3,
    title: 'Provision mensuelle 13e salaire',
    description: 'Comptabilisez la provision mensuelle de janvier pour le 13e salaire de l\'équipe.',
    note: 'On débite les charges et on crédite 2300 Passifs de régularisation (pas 2270). La provision sera soldée en décembre lors du versement effectif.',
    data: [
      { label: 'Provision 13e brut (1/12)', value: 'CHF 1\'667.00' },
      { label: 'Provision charges patronales (1/12)', value: 'CHF 233.00' },
    ],
    ecritures: [
      { id: 'e1', libelle: 'Provision 13e salaire janvier (1/12)', debit: { num: '5000', label: 'Salaires' }, credit: { num: '2300', label: 'Passifs de régularisation' }, amount: 1667 },
      { id: 'e2', libelle: 'Provision charges patronales 13e janvier', debit: { num: '5700', label: 'Charges sociales patronales' }, credit: { num: '2300', label: 'Passifs de régularisation' }, amount: 233 },
    ],
  },
  {
    id: 'sal-e-05', group: 'salaires-ecritures', type: 'qcm', tag: 'salaires', difficulty: 2,
    title: 'Impact salaire sur le résultat',
    description: 'Pour Théo Keller (brut CHF 6\'000 + charges patronales CHF 1\'014), la charge totale dans le compte de résultat est :',
    options: [
      { id: 'a', text: 'CHF 5\'256 (salaire net versé)', correct: false },
      { id: 'b', text: 'CHF 6\'000 (salaire brut)', correct: false },
      { id: 'c', text: 'CHF 7\'014 (brut + charges patronales)', correct: true },
      { id: 'd', text: 'CHF 6\'744 (brut + déductions)', correct: false },
    ],
    explanation: 'Résultat : 5000 Salaires CHF 6\'000 + 5700 Charges patronales CHF 1\'014 = CHF 7\'014 au total. Les déductions employé (CHF 744) ne sont pas une charge supplémentaire — elles transitent par 2270.',
  },
  {
    id: 'sal-ecr-05', group: 'salaires-ecritures', type: 'journal', tag: 'salaires', difficulty: 3,
    title: 'Comptabilisation complète du salaire + versements',
    description: 'Passez toutes les écritures pour un salaire brut de CHF 7\'000 :\n1. Comptabilisation du salaire brut et déductions\n2. Comptabilisation des charges patronales\n3. Versement du salaire net\n4. Versement des charges sociales aux caisses',
    data: [
      { label: 'Brut', value: 'CHF 7\'000' },
      { label: 'Déductions employé', value: 'CHF 868 (AVS 371, AC 77, LAANP 70, LPP 350)' },
      { label: 'Charges patronales', value: 'CHF 903.50 (AVS 371, AC 77, LAA 35, LPP 420.50)' },
      { label: 'Net à payer', value: 'CHF 6\'132' },
    ],
    ecritures: [
      { id: 'e1', libelle: 'Salaire brut', debit: { num: '5000', label: 'Salaires' }, credit: { num: '2160', label: 'Salaires à payer' }, amount: 7000 },
      { id: 'e2', libelle: 'Déductions sociales employé', debit: { num: '2160', label: 'Salaires à payer' }, credit: { num: '2270', label: 'Charges sociales à payer' }, amount: 868 },
      { id: 'e3', libelle: 'Charges patronales', debit: { num: '5700', label: 'Charges sociales' }, credit: { num: '2270', label: 'Charges sociales à payer' }, amount: 903.50 },
      { id: 'e4', libelle: 'Versement salaire net', debit: { num: '2160', label: 'Salaires à payer' }, credit: { num: '1020', label: 'Banque' }, amount: 6132 },
      { id: 'e5', libelle: 'Versement charges sociales aux caisses', debit: { num: '2270', label: 'Charges sociales à payer' }, credit: { num: '1020', label: 'Banque' }, amount: 1771.50 },
    ],
  },
  {
    id: 'sal-ecr-06', group: 'salaires-ecritures', type: 'journal', tag: 'salaires', difficulty: 2,
    title: 'Provision mensuelle du 13e salaire',
    description: 'SwiSSwatch SA provisionne le 13e salaire chaque mois. Masse salariale brute mensuelle : CHF 25\'000. Passez l\'écriture de provision de janvier.',
    data: [
      { label: 'Masse salariale brute', value: 'CHF 25\'000/mois' },
      { label: '13e salaire', value: '1/12 de la masse annuelle' },
    ],
    note: 'Provision mensuelle = masse brute / 12 = 25\'000 / 12 = CHF 2\'083.35',
    ecritures: [
      { id: 'e1', libelle: 'Provision 13e salaire (1/12)', debit: { num: '5000', label: 'Salaires' }, credit: { num: '2300', label: 'Passifs de régularisation' }, amount: 2083.35 },
    ],
  },
];